import React, { useState } from "react";
import { Modal } from "../Modal";
import { LoadingSpinner } from "../LoadingSpinner/component";
import { track } from "~/modules/analytics/track";
import { ContactUserEvents } from "~/modules/analytics/events/contact";

// // // //

interface Props {
    title: string;
    body: string;
    buttonText: React.ReactNode;
    buttonClassName: string;
    modalSize?: "md" | "lg";
    forceShow?: boolean;
    onHide?: () => void;
    formUrl?: string;
    analyticsLabel: string;
    analyticsEventProperties?: Record<string, unknown>;
}

const DEFAULT_FORM_URL = "https://forms.default.com/16925";

export function DefaultFormModal(props: Props) {
    const {
        title,
        body,
        buttonClassName,
        buttonText,
        modalSize = "md",
        forceShow = false,
        onHide: onClose,
        formUrl = DEFAULT_FORM_URL,
        analyticsLabel,
        analyticsEventProperties = {},
    } = props;
    const [showingDataModal, showDataModal] = useState(forceShow);
    const [isLoading, setIsLoading] = useState(true);

    const handleHide = () => {
        showDataModal(false);
        setIsLoading(true); // Reset loading state when modal closes
        if (onClose) {
            onClose();
        }
    };

    return (
        <React.Fragment>
            <Modal
                size={modalSize}
                show={showingDataModal}
                allowScroll
                onHide={handleHide}
            >
                <div
                    className="pt-6 px-6 flex flex-col bg-card"
                    style={{ height: "856px" }}
                >
                    <div className="flex flex-col">
                        <p className="text-2xl">{title}</p>
                        <p className="font-light">{body}</p>
                    </div>
                    <div className="flex flex-col min-h-180 relative">
                        {isLoading && (
                            <div className="absolute inset-0 flex items-center justify-center bg-card">
                                <LoadingSpinner size={24} />
                            </div>
                        )}
                        <iframe
                            className="h-full min-h-180"
                            src={formUrl}
                            onLoad={() => setIsLoading(false)}
                        />
                    </div>
                </div>
            </Modal>

            {!forceShow && (
                <button
                    className={`${buttonClassName} cursor-pointer`}
                    onClick={() => {
                        if (analyticsLabel) {
                            track(ContactUserEvents.OpenContactFormModal, {
                                title,
                                label: analyticsLabel,
                                ...analyticsEventProperties,
                            });
                        }
                        showDataModal(true);
                    }}
                >
                    {buttonText}
                </button>
            )}
        </React.Fragment>
    );
}
